import { render } from "./taxCategories.vue?vue&type=template&id=f7c65ff6"
import script from "./taxCategories.vue?vue&type=script&lang=js"
export * from "./taxCategories.vue?vue&type=script&lang=js"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__